import { allAvailableDatesField } from './fields/allAvailableDates.field';
import { setsAvailableDatesField } from './fields/setsAvailableDates.field';

export const eeDatesPolicies = {
    setsAvailableDates: setsAvailableDatesField,
    allAvailableDates: allAvailableDatesField,
};
